import React from 'react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const Login = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex bg-white" data-testid="login-page">
      {/* ============ LEFT — Full-bleed visual ============ */}
      <div className="relative hidden lg:flex lg:w-[58%] overflow-hidden">
        {/* Base deep-teal canvas */}
        <div className="absolute inset-0 bg-[#0d2c2a]" />

        {/* Animated gradient mesh */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -left-32 w-[640px] h-[640px] rounded-full bg-[#2eb4ac] opacity-40 blur-3xl animate-mesh-1" />
          <div className="absolute top-1/3 -right-32 w-[560px] h-[560px] rounded-full bg-[#5fd6cf] opacity-30 blur-3xl animate-mesh-2" />
          <div className="absolute -bottom-32 left-1/4 w-[520px] h-[520px] rounded-full bg-[#0aa39a] opacity-35 blur-3xl animate-mesh-3" />
        </div>

        {/* Fine noise / grain overlay (CSS pattern) */}
        <div className="absolute inset-0 opacity-[0.07] pointer-events-none mix-blend-overlay"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          }}
        />

        {/* Decorative SVG waveform (call-intelligence motif) */}
        <svg
          className="absolute bottom-20 left-12 right-12 opacity-80"
          height="120"
          viewBox="0 0 600 120"
          preserveAspectRatio="none"
          fill="none"
        >
          {Array.from({ length: 48 }).map((_, i) => {
            const heights = [18, 34, 12, 56, 28, 70, 42, 22, 60, 38, 18, 44, 26, 76, 32, 14, 52, 30, 66, 40, 22, 58, 34, 18, 48, 28, 72, 36, 20, 54, 30, 16, 62, 40, 24, 50, 30, 18, 68, 36, 22, 58, 32, 16, 46, 28, 70, 38];
            const h = heights[i];
            return (
              <rect
                key={i}
                x={i * 12.5 + 2}
                y={(120 - h) / 2}
                width="6"
                height={h}
                rx="3"
                fill="white"
                opacity={0.25 + (h / 100)}
                style={{
                  animation: `wave-pulse 2.4s ease-in-out infinite`,
                  animationDelay: `${(i * 0.06) % 1.6}s`,
                  transformOrigin: `${i * 12.5 + 5}px 60px`,
                }}
              />
            );
          })}
        </svg>

        {/* Brand mark — top-left */}
        <div className="relative z-10 p-12 w-full flex flex-col">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-2xl bg-white/15 backdrop-blur-sm flex items-center justify-center ring-1 ring-white/20">
              <span className="text-xl font-bold text-white">H</span>
            </div>
            <span className="text-xl font-semibold text-white tracking-tight">Helix</span>
          </div>

          {/* Tagline — vertically centered */}
          <div className="flex-1 flex flex-col justify-center max-w-xl">
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#5fd6cf] mb-6">
              Sales Call Intelligence
            </p>
            <h1 className="text-5xl xl:text-6xl font-bold text-white leading-[1.05] tracking-tight mb-6">
              Turn every call into a <span className="text-[#5fd6cf]">closed deal</span>.
            </h1>
            <p className="text-lg text-white/70 leading-relaxed max-w-md">
              Helix listens, transcribes, and reads the room — so your reps walk into every conversation knowing exactly what to say next.
            </p>

            {/* Stat strip */}
            <div className="mt-12 flex items-center gap-8">
              <div>
                <p className="text-3xl font-bold text-white">3.4×</p>
                <p className="text-xs text-white/60 mt-1 uppercase tracking-wider">Faster follow-ups</p>
              </div>
              <div className="w-px h-12 bg-white/15" />
              <div>
                <p className="text-3xl font-bold text-white">98%</p>
                <p className="text-xs text-white/60 mt-1 uppercase tracking-wider">Hinglish accuracy</p>
              </div>
              <div className="w-px h-12 bg-white/15" />
              <div>
                <p className="text-3xl font-bold text-white">12 s</p>
                <p className="text-xs text-white/60 mt-1 uppercase tracking-wider">Avg. analysis time</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <p className="text-xs text-white/40 mt-12">
            © 2026 Helix · Powered by Groq + OpenAI Whisper
          </p>
        </div>
      </div>

      {/* ============ RIGHT — Clean white form panel ============ */}
      <div className="flex-1 flex items-center justify-center px-6 py-10 bg-white">
        <div className="w-full max-w-sm">
          {/* Mobile brand mark */}
          <div className="lg:hidden flex items-center gap-3 mb-10 justify-center">
            <div className="w-11 h-11 rounded-2xl bg-[#2eb4ac] flex items-center justify-center">
              <span className="text-xl font-bold text-white">H</span>
            </div>
            <span className="text-xl font-semibold text-slate-900">Helix</span>
          </div>

          {/* Heading */}
          <div className="mb-10">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#2eb4ac] mb-3">
              Welcome back
            </p>
            <h2 className="text-3xl font-bold text-slate-900 leading-tight mb-3">
              Sign in to your workspace
            </h2>
            <p className="text-sm text-slate-500 leading-relaxed">
              Continue with your work Google account. We'll keep you signed in across sessions.
            </p>
          </div>

          {/* Google CTA */}
          <button
            onClick={handleGoogleLogin}
            className="group w-full flex items-center justify-center gap-3 px-6 py-3.5 bg-slate-900 text-white rounded-xl hover:bg-slate-800 active:scale-[0.99] transition-all shadow-sm"
            data-testid="google-signin-btn"
          >
            <svg className="w-5 h-5 bg-white rounded-full p-[2px]" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="font-medium text-sm">Continue with Google</span>
            <span className="ml-1 transition-transform group-hover:translate-x-0.5">→</span>
          </button>

          {/* Divider */}
          <div className="flex items-center gap-4 my-8">
            <div className="flex-1 h-px bg-slate-200" />
            <span className="text-xs text-slate-400 uppercase tracking-wider">Secure access</span>
            <div className="flex-1 h-px bg-slate-200" />
          </div>

          {/* Trust badges */}
          <div className="flex items-center justify-center gap-6 text-xs text-slate-400">
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              SOC 2 ready
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              Encrypted at rest
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              GDPR aligned
            </span>
          </div>

          {/* Legal */}
          <p className="mt-10 text-center text-xs text-slate-400 leading-relaxed">
            By continuing you agree to our{' '}
            <a href="#" className="text-slate-600 hover:text-[#2eb4ac] underline-offset-4 hover:underline transition-colors">Terms</a>
            {' '}and{' '}
            <a href="#" className="text-slate-600 hover:text-[#2eb4ac] underline-offset-4 hover:underline transition-colors">Privacy Policy</a>.
          </p>
        </div>
      </div>

      {/* Self-contained keyframes */}
      <style>{`
        @keyframes mesh-1 {
          0%,100% { transform: translate(0,0) scale(1); }
          50%     { transform: translate(40px,30px) scale(1.1); }
        }
        @keyframes mesh-2 {
          0%,100% { transform: translate(0,0) scale(1); }
          50%     { transform: translate(-50px,-20px) scale(1.08); }
        }
        @keyframes mesh-3 {
          0%,100% { transform: translate(0,0) scale(1); }
          50%     { transform: translate(20px,-40px) scale(1.12); }
        }
        .animate-mesh-1 { animation: mesh-1 14s ease-in-out infinite; }
        .animate-mesh-2 { animation: mesh-2 18s ease-in-out infinite; }
        .animate-mesh-3 { animation: mesh-3 16s ease-in-out infinite; }
        @keyframes wave-pulse {
          0%,100% { transform: scaleY(0.6); }
          50%     { transform: scaleY(1.2); }
        }
      `}</style>
    </div>
  );
};

export default Login;
